export const RecipientInfo = ({ recipient }) => {
  return (
    <div className="mt-2 mb-2 text-center w-full">
      How can <b>{recipient?.name}</b> assist you today?
    </div>
  );
};
